import { forwardRef } from 'react';

export interface ManifestRenderContainerProps {
  children?: React.ReactNode;
}

export const ManifestRenderContainer = forwardRef<HTMLDivElement, ManifestRenderContainerProps>((props, ref) => {
  return (
    <div style={{ display: 'none' }}>
      <div ref={ref} style={{ margin: '20px' }}>
        {props.children}
      </div>
    </div>
  );
});

export interface ManifestProps {
  rows: any[];
  columns: any[];
  totalCons: number;
  totalPallets: number;
  totalWeight: number;
  logo: string;
  isNewGrid: boolean;
  accountCodes: string;
  children?: React.ReactNode;
}

const FONT_SIZE = '10px';

const Manifest = forwardRef<HTMLDivElement, ManifestProps>(
  ({ rows, columns, totalCons = 0, totalPallets = 0, totalWeight = 0, logo, isNewGrid, accountCodes }, ref) => {
    const logoIsPresent = Boolean(logo) && logo.length > 0;

    return (
      <main
        id="printableTable"
        ref={ref}
        style={{ position: 'relative', paddingTop: logoIsPresent ? '50px' : '20px', color: 'black' }}>
        {logoIsPresent && (
          <section style={{ position: 'absolute', right: 0, top: 0 }}>
            <img src={logo} style={{ width: '100px', height: '100px', objectFit: 'contain' }} alt="" />
          </section>
        )}
        <section style={{ width: '100%', textAlign: 'center', fontSize: FONT_SIZE, fontWeight: 'bold' }}>
          {accountCodes && accountCodes.trim().length > 0 ? (
            <>
              <span style={{ display: 'block' }}>Manifest from {accountCodes}</span>
              <span style={{ display: 'block' }}>Created</span>
            </>
          ) : (
            <span style={{ display: 'block' }}>Manifest Created</span>
          )}
          <span style={{ display: 'block' }}>
            {new Date().toLocaleDateString(undefined, {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        </section>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: FONT_SIZE, marginTop: '20px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid black' }}>
              {columns.map(column => (
                <th
                  key={isNewGrid ? column.headerId : column.field}
                  style={{ padding: '8px', textAlign: 'left', width: `${column.width}px` }}>
                  {isNewGrid ? column.caption : column.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id} style={{ borderBottom: '1px solid black' }}>
                {columns.map(column => {
                  // Check if the value is a date string
                  const value = isNewGrid ? row[column.dataField] : row[column.field];
                  const date = new Date(value);
                  const formattedValue =
                    !isNaN(date.getTime()) && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
                      ? date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })
                      : value;

                  return (
                    <td
                      key={isNewGrid ? column.headerId : column.field}
                      style={{ paddingInline: '8px', textAlign: 'left' }}>
                      {formattedValue}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <section style={{ fontSize: FONT_SIZE, marginTop: '20px', fontWeight: 'bold' }}>
          <div>
            <span style={{ display: 'inline-block', width: '80px' }}>Total Cons:</span>
            <span>{totalCons}</span>
          </div>

          <div>
            <span style={{ display: 'inline-block', width: '80px' }}>Total Pallets</span>
            <span>{totalPallets}</span>
          </div>

          <div>
            <span style={{ display: 'inline-block', width: '80px' }}>Total Weight</span>
            <span>
              {totalWeight}
              {/* <small>Kgs</small> */}
            </span>
          </div>
        </section>
        <section
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            marginTop: '0px',
            fontSize: FONT_SIZE,
            fontWeight: 'bold',
            borderTop: '1px solid black',
            borderBottom: '1px solid black',
            paddingBlock: '10px'
          }}>
          <div style={{ flex: 1 }}>
            <span>Driver Name: </span>
          </div>
          <div style={{ flex: 1 }}>
            <span>Driver Signature: </span>
          </div>
          <div style={{ flex: 1 }}>
            <span>Date/Time: </span>
          </div>
        </section>
      </main>
    );
  }
);

export default Manifest;
